import { render } from "./Copyright.vue?vue&type=template&id=8990a182&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"

import "./Copyright.vue?vue&type=style&index=0&id=8990a182&scoped=true&lang=stylus"

import exportComponent from "F:\\xampp\\htdocs\\GITLAB\\2026\\tokyo-shoseki\\R9 Site Maintenance January 2026\\08e_a2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8990a182"]])

export default __exports__